import React, { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import IconPopover from '@core/dashboard/components/IconPopover';
import OVERLAYS from '@constants/overlays';
import { ToolsIcon } from '@icons';
import { useToolsState } from './hooks';
import Tools from './Tools';
import {
  ModalContainer,
  Header,
} from '@core/dashboard/components/PopoverModal';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';
import { useTools } from './Tools/hooks';

const ToolActions = () => {
  const { t: translate } = useTranslation();

  const { resetState } = useToolsState();
  const tools = useTools();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.TOOLS_BUTTON,
  );

  useEffect(() => resetState, []);

  if (tools.length === 0) {
    return null;
  }

  return (
    <IconPopover
      icon={<ToolsIcon />}
      label={translate('actions.tools')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName="tools"
      overlayName={OVERLAYS.TOOL_ACTIONS}
      disabled={isDisabledClientSpecific}
    >
      {({ onClose }) => (
        <ModalContainer
          header={
            <Header text={translate('actions.tools')} onClose={onClose} />
          }
        >
          <Tools onClose={onClose} />
        </ModalContainer>
      )}
    </IconPopover>
  );
};

export default ToolActions;
